module.exports = {
  /**
   * Created for packages/libs/eslint-plugin-amp-internal
   * Add new keys here for custom events, yeah?
   */
  GENERAL_ERROR: 'AmpError',
  USER_CTX_UPDATE: 'UserCtxUpdate',
  WINDOW_LOAD: 'load',
  WINDOW_BEFOREUNLOAD: 'beforeunload',
  WINDOW_RESIZE: 'resize',
  STORAGE: 'storage',
  KEY_DOWN: 'keydown',
  MOUSE_DOWN: 'mousedown',
  MOUSE_UP: 'mouseup',
  MESSAGE: 'message',
  LOCALE_UPDATE: 'localeUpdate',
  ONPOPSTATE: 'onpopstate',
  POPSTATE: 'popstate',
  TEACHER_NO_CLASS: 'TeacherNoClass',
  TEACHER_CLASSES_TO_SETUP: 'TeacherClassesToSetUp',
  NO_STUDENTS_IN_CLASS: 'NoStudentsInClass',
  GLOBAL_NOTIFICATION: 'GlobalNotification',
  SINGLE_SPA_BEFORE_ROUTING_EVENT: 'single-spa:before-routing-event',
  SINGLE_SPA_FIRST_MOUNT: 'single-spa:first-mount',
  SINGLE_SPA_ROUTING_EVENT: 'single-spa:routing-event',
  CONFIRM_NAVIGATION: 'AmpConfirmNavigation',
  FAVORITES: 'Favorites',
  SEARCH_NO_RESULTS: 'searchNoResults',
  USER_PROFILE_LOADED: 'userProfileLoaded',
  EDIT_USER_PROFILE: 'editUserProfile',
  PATHWAYS_EDITED: 'pathwaysEdited',
  CLASS_SETUP: 'isClassSetupRequired',
  EDIT_CLASS: 'editClassSetup',
};
